export function formatPrice(
  packagePriceInCents: number,
  removeDollarSign = false,
) {
  const priceInDollars = packagePriceInCents / 100;
  const formattedPrice = priceInDollars.toLocaleString("en-US", {
    currency: "USD",
    style: "currency",
  });
  if (removeDollarSign) {
    return formattedPrice.replace("$", "");
  }
  return formattedPrice;
}

export function getCents(price: number) {
  if (!Number.isInteger(price)) {
    const cents = Number(((price - Math.floor(price)) * 100).toFixed(0));
    return cents < 10 ? `0${cents}` : cents;
  } else {
    return "00";
  }
}

export function getDollars(price: number) {
  return price && Math.floor(price).toFixed(0);
}
